// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Аналітичні інструменти» (Analytical tools, ключ `atool`, група `analysis`). */
export const analyticalToolsManifest: IModuleManifest = {
  key: 'atool',
  group: 'analysis',
  slug: 'analytical-tools',
  prefix: 'ATL',
  name: { en: 'Analytical tools', uk: 'Аналітичні інструменти' },
  entities: [
    { key: 'atool', slug: 'atool', name: { en: 'Analyses', uk: 'Аналізи' }, main: true },
    { key: 'afish', slug: 'afish', name: { en: 'Fishbone causes', uk: 'Причини (fishbone)' }, main: false },
    { key: 'atows', slug: 'atows', name: { en: 'TOWS strategies', uk: 'Стратегії TOWS' }, main: false },
    { key: 'pswot', slug: 'pswot', name: { en: 'SWOT', uk: 'SWOT' }, main: false },
  ],
  loadState: () => import('./state/analyticalToolsSlice').then((m) => m.analyticalToolsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
